import { randomInt } from "./random";

/**
 * Per-action rate limiter: lets a mob act "once every `period` turns" while still
 * being driven once per turn. `period === 1` is always-ready (no restriction).
 *
 * The starting cooldown is randomized in `[0, period)` so a group of identical
 * slow mobs spawns out of phase and never moves in lockstep.
 */
export class Cadence {
	readonly period: number;
	cooldown: number;

	constructor(period: number) {
		this.period = Math.max(1, period);
		this.cooldown = randomInt(0, this.period - 1);
	}

	isReady(): boolean {
		return this.cooldown <= 0;
	}

	/** Call once when the gated action actually happens. */
	consume(): void {
		this.cooldown = this.period;
	}

	/** Advance one turn. */
	tick(): void {
		if (this.cooldown > 0) this.cooldown--;
	}

	stagger(turns: number = 1): void {
		// +1 because the owner ticks once more this turn before it can act.
		this.cooldown = Math.max(this.cooldown, turns + 1);
	}

	restore(cooldown: number): void {
		this.cooldown = cooldown;
	}
}
